import React, { Component } from 'react';
import "../../css/components/ImageLoader.css";
import HmAjax from '../../util/HmAjax';
import NativeAjax from '../../util/NativeAjax';
import ImageUpload from '../imageLoader/ImageUpload';
import $ from 'jquery';
import Loader from 'react-loader-spinner';
import { confirmAlert } from 'react-confirm-alert'; 
import 'react-confirm-alert/src/react-confirm-alert.css';
import error_icon from './images/error_icon.png';
import HmEventRegistry from '../../model/HmEventRegistry';

class FileUpload extends ImageUpload {
  constructor(props) {
    super(props);
    this.state = {
      file: '',
      fileLoaded: false,
      serverMessage:'',
      uploading:false,
      trackId:null,
      RegistrationOpen:false
    };
    this.handleFileChange = this.handleFileChange.bind(this);
    this._handleSubmit = this._handleSubmit.bind(this);
    this.prevFn=this.prevFn.bind(this);
    this.getRegForm =  this.getRegForm.bind(this);
    this.deleteImage = this.deleteImage.bind(this);

    this.callback = this.props.callback || function(imageUrl){};    
    this.errorFile = "";

    this.maxPictureSizeInKb = 200;
    this.maxFileNameLength = 85;
    this.picExtensions = ["xlsx"];
    this.unsupportedCharacters = "?!#$%&<>~:;'^\"\\/";
  }

 componentDidMount(){
  super.componentDidMount();
  let RegistrationOpen = this.props.RegistrationOpen || false;
  this.setState({RegistrationOpen:RegistrationOpen});
  //console.log("RegistrationOpen componentDidMount F",RegistrationOpen);
  HmEventRegistry.fireEvent("INITIATE_GA_EVENT");
 }

setCurrentImage(){

}

uploadFile(xlsxFile, elem) {
  var me = this;
  me.setState({fileLoaded:false,serverMessage:""});
  me.errorFile = "";
  if(xlsxFile){
   // console.log("xlsxFile :::", xlsxFile);

   var uploadValid = true;
   var errLabel = "";
   var errMsg = "";

   if(xlsxFile.name && !me.isFileNameLengthValid(xlsxFile.name)){
    uploadValid = false;
    errLabel = me.rb("pic.label.file_name_length_invalid");
    errMsg = me.rb("pic.msg.file_name_length_invalid").replace("{1}",me.maxFileNameLength);
  }else if(xlsxFile.name && !me.isFileNameValid(xlsxFile.name)){
    uploadValid = false;
    errLabel = me.rb("pic.label.file_name_invalid");
    errMsg = me.rb("pic.msg.file_name_invalid").replace("{1}",me.unsupportedCharacters.split("").join(" "));
  }else if(xlsxFile.name && !me.isFileTypeValid(xlsxFile.name)){
    uploadValid = false;
    errLabel = me.rb("pic.label.file_format_invalid");
    errMsg = me.rb("pic.msg.file_format_invalid").replace("{1}",me.picExtensions.join("/"));
  }else if(xlsxFile.size && !me.isSizeValid(xlsxFile.size)){
    uploadValid = false;
    errLabel = me.rb("contest.msg.file_size_exceed");
    errMsg = me.rb("contest.msg.file_size_exceed_desc").replace("{1}",me.maxPictureSizeInKb);
  }


  if(!uploadValid){
    me.showAlert(errLabel,errMsg);
        //Clear the element for retries
        if(elem){
          elem.value = null;
        }
        me.setState({file: ' '});
        return ;
      }
      //console.log("me.getUserCount() ",me.getUserCount());
      me.fileUploadFn(xlsxFile)
    //  if(me.getUserCount()>0){
    //   me.alertWindowFn(xlsxFile)
    //  }else{
    //   me.fileUploadFn(xlsxFile)
    //  }
    }
  }

  getUserCount(){
    let me=this;
    let userCount = 0;
    if(typeof me.props.getUserCount === "function"){
      userCount = me.props.getUserCount();
    }
    return userCount;
  }

  alertWindowFn(file){
    let me=this;

    var buttons = [{
      label:me.rb("stud.prep.yes"),
      handler: () =>{ 
        // new HmAjax(me.getUrlFor("PROFILE_PIC")).delete(success, failure);
        me.fileUploadFn(file)
      }
    },{
      label:me.rb("stud.prep.no"),
      handler: () =>{ 
        me.setState({file:undefined});
        // new HmAjax(me.getUrlFor("PROFILE_PIC")).delete(success, failure);
        //me.uploadFile(me.state.file)
      }
    }];
  
    this.showAlert(me.rb("alert"),me.rb("contest.fileupload.alertdesc"),buttons);
  }


  errorWindow(errFile,trackId){
    let me=this;
    confirmAlert({
		  customUI: ({ onClose }) => {
		    return (
		      <div id="UploadFailed" className='custom-ui-alert'>

        
				<div className="title">
          <i class="material-icons">error</i> 
           {this.rb("contest.fileupload.errdownload")}</div>

         <div className="desc"> 
         <div>{this.rb("contest.fileupload.errdownload1")}</div>
         
          <div>{this.rb("contest.fileupload.errdownload2")}</div>
           </div>

           <div className="dwnicon vert-move">
             <img src={error_icon} alt="Error file"></img>
            {/* <i class="material-icons">
              arrow_downward
              </i> */}
           </div>

           <div className="downloadbtn" onClick={
             () => { 
                window.open(me.getUrlFor("CONTEST_DWNLOD_FILE")+trackId,"_blank");
               onClose();
            }
           }>
            <span>{errFile}</span>
           </div>
		      </div>
		    )
		  },
		  closeOnClickOutside : false
		})
  }

  fileUploadFn(xlsxFile){
    let me=this;
    me.setState({uploading:true});

    var success = function(response){
      me.setState({uploading:false});
      if(response!==null){
          if(response && response.validationStatus && response.validationStatus === "success"){
            if(response.isValidFile){
              let isTimeValid = (response.isTimeValid) ? response.isTimeValid : false;
              if(isTimeValid){
                if(response.insertStatus==="success"){
                  me.setState({fileLoaded:true,serverMessage:response.insertStatus,trackId:response.trackId});
                  me.showSuccess();
                  let existingUsers = (response.existingUsers) ? JSON.parse(response.existingUsers) : null;
                  let uploadUsers = JSON.parse(existingUsers);
                  //console.log("uploadUsers ",uploadUsers);
                  me.callback.apply(this,[response.trackId,true,uploadUsers]);
                  if(typeof me.props.getCount === "function"){
                    me.props.getCount(true);
                  }
                }else if(response && response.status && response.insertStatus === "contest_communication_failure"){
                  me.showAlert(me.rb("system_error"),me.rb("contest.err.generic"));
                  return;
                }else{
                  me.setState({fileLoaded:true,serverMessage:response.insertStatus,trackId:response.trackId});
                }
                
               }else{
                if(response && response.timeValidationStatus && (response.timeValidationStatus === "regn_already_over" || response.timeValidationStatus === "regn_not_started")){
                  me.showAlert(me.rb("contest.fileupload.regis_status"),me.rb("contest.file."+response.timeValidationStatus));
                }
               }
            }
            else{
              let errFile = response.errFile || "Error File";
              me.errorFile = errFile;
              let trackId = response.trackId || 0;
              me.errorWindow(errFile,trackId)
              me.setState({fileLoaded:true,serverMessage:response.validationErrorsList[0],trackId:response.trackId});
              me.callback.apply(this,[response.trackId]);
            }
           
          }
          else if(response && response.status && response.validationStatus === "invalid_file_format:allowed_formats:xlsx"){
            me.showAlert(me.rb("system_error"),me.rb("pic.msg.file_format_invalid").replace("{1}",me.picExtensions.join("/")));
            return;
          }
          
        }
    } 
  
    var failure = function(err){
      me.setState({uploading:false});
    }

      let contest_host = this.props.contest_host || this.getSelectedContestGroup();
      let dataAppend = this.props.dataAppend || false;
      var myObj = {
        "file":xlsxFile,
        "contest_host" : contest_host
      }
      new NativeAjax(this.getUrlFor("CONTEST_REG_UPLOAD_FORM")+"?overwrite="+dataAppend).enableCORS().setFormData(myObj).post(success, failure);
  }

  //Yet to implemented
  deleteImage(){
    var me = this;
    var success = function(resp){
      me.setState({fileLoaded:false});
      me.callback.apply(this,['']);
    }

    var failure = function(err){

    }

    var buttons = [{
      label:me.rb("btn.yes.delete_pic"),
      handler: () =>{ 
        new HmAjax(me.getUrlFor("PROFILE_PIC")).delete(success, failure);
      }
    },{
      label:me.rb("btn.no.delete_pic")
    }];

    me.showAlert(me.rb("alert.label.delete_pic"),me.rb("alert.msg.delete_pic"),buttons);


  }

  prevFn(e){
    if(this.state.RegistrationOpen){
      $("#brwicon").trigger("click");
    }
  }

  getRegForm(){
    const contestHostGrp = (window.contest_host_groups && window.contest_host_groups[this.getContestHost()]) ? window.contest_host_groups[this.getContestHost()] : null;

    if(contestHostGrp != null){
      //VERY IMPORTANT: Paths are configured in lower case and hence toLowerCase()
      //S3 URL for getting the reg forms
      window.open(this.getUrlFor("CONTEST_REG_FORM_NEW").replace("{#contestHostGrp}",contestHostGrp.toLowerCase()),"_blank");
    }else{
      //Fallaback approach
      //Below is for older reg forms - driven by Apache
      window.open(this.getUrlFor("CONTEST_REG_FORM"),"_blank");      
    }
  }

  _handleSubmit(e) {
    let me=this;
    e.preventDefault();
  //alert("upload");

  this.uploadFile(this.state.file)
    // TODO: do something with -> this.state.file
  }

  handleFileChange(e) {
    var me = this;
    e.preventDefault();

    let reader = new FileReader();
    let file = e.target.files[0];

    //clear older image if available
    e.target.value = null;

    reader.onloadend = () => {
      this.setState({
        file: file
      });
    }
    
    if(file==="undefined" || file===undefined){
      //alert("no file chosen");

    }else{
      me.uploadFile(file, e.target);
    }
  }

  showSuccess(){
    let me=this;
    $(".server-messages.success").fadeIn("fast");
    setTimeout(()=>{
      me.hideSuccess()
    },5000);
  }

  hideSuccess(){
    $(".server-messages.success").fadeOut("slow");
  }

  renderUploadUI(){
    let RegistrationOpen = this.state.RegistrationOpen;
    let RegClass = "";
    if(!RegistrationOpen){
        RegClass = "disabled";
    }

    

    return (
        <div id="fileupload">
       
          <div className="reg-step">
            <span className="steps">1</span>{this.rb("contest.reg.heading")}
            <div className="regform" data-ga="Template download" onClick={this.getRegForm} >
              <span className="reg-text">{this.rb("contest.regform")}</span><i className="material-icons">get_app</i>
            </div>
          </div>
          <div className="instruct-content">
          <ul><i className="material-icons">info</i><span>{this.rb("instruct-title")}</span>
            <li>{this.rb("instruct-point1")}</li>
            <li>{this.rb("instruct-point2")}</li>
            <li>{this.rb("instruct-point3")}</li>
          </ul>
          <div>
          <span className="instr-note">
          {this.rb("instruct-point5")}
          </span>
          </div>
          </div>
        <hr/>
       

        <div className="reg-step"><span className="steps">2</span>{this.rb("contest.uploadreg")}</div>

        <div className="fileupload-box">
        <form onSubmit={this._handleSubmit}>    
        <input type="file" id="brwicon" accept="file/*" onChange={this.handleFileChange} ref="test_input"/>
        </form>

        <div className={"browse "+RegClass} data-ga="browse button" onClick={this.prevFn} >{this.rb("contest.browsefile")}</div>

        {(() => { 
        
        if(this.state.uploading){
            return(
              <div className="text-left">
            <Loader 
            type="Watch"
            color="#00BFFF"
            height="40"	
            width="40"
            />
            </div>
            )
          }
        })()}

        {(() => { 
        
        if(!this.state.uploading){
          if(this.state.fileLoaded && this.state.serverMessage==="success"){
            return (
              <div className="server-messages success">File Uploaded Successfully</div>
              );
            }else if(this.state.fileLoaded && this.state.serverMessage!=="success"){
              return (
                <div className="server-messages error"><a style={{color:"red"}} href={this.getUrlFor("CONTEST_DWNLOD_FILE")+this.state.trackId}><div>Download the <span>{this.errorFile}</span><i className="material-icons">get_app</i></div></a></div>
                );
          }
        }

        })()}

        </div>
        <hr/>
        <div className="reg-step"><span className="steps">3</span>{this.rb("contest.regtab")}</div>
        </div>
    )
}


    render() {
    return super.render(
        <div>
            {this.renderUploadUI()}
        </div>
    )
  }

}

export default FileUpload;


// WEBPACK FOOTER //
// ./src/components/fileLoader/FileUpload.js